import { PaymentsProps } from '../icon-types';
import { SvgWrapper } from '../svg-wrapper/payment-wrapper';

export function DiscoverIcon(props: PaymentsProps) {
  return (
    <SvgWrapper {...props}>
      <g fill="none" fillRule="evenodd">
        <rect
          x={0.5}
          y={0.5}
          width={35}
          height={23}
          rx={4}
          fill="#FFF"
          stroke="#CFD4D9"
        />
        <g fillRule="nonzero">
          <path
            d="M7.062 10.023H6v3.815h1.048c.566 0 .966-.128 1.324-.442.414-.355.676-.896.676-1.466 0-1.124-.814-1.907-1.986-1.907Zm.841 2.875c-.234.2-.524.3-.993.3h-.193v-2.52h.193c.47 0 .745.085.993.299.249.227.4.583.4.953s-.151.74-.4.968Zm1.476.94h.718v-3.815h-.718v3.815Zm2.483-2.349c-.441-.17-.565-.27-.565-.484 0-.242.234-.412.537-.412.221 0 .4.085.58.298l.386-.498a1.601 1.601 0 0 0-1.09-.427c-.662 0-1.158.47-1.158 1.096 0 .527.234.783.91 1.04.29.099.428.17.497.213.151.1.22.242.22.398 0 .314-.234.541-.565.541-.331 0-.62-.185-.786-.512l-.455.47c.33.498.73.726 1.282.726.745 0 1.27-.513 1.27-1.253 0-.612-.25-.883-1.063-1.196Zm1.283.441c0 1.125.855 1.993 1.958 1.993.304 0 .58-.057.897-.213v-.883c-.29.299-.538.427-.869.427-.717 0-1.241-.555-1.241-1.324 0-.726.538-1.31 1.213-1.31.345 0 .607.129.897.428v-.869a1.688 1.688 0 0 0-.883-.242c-1.09 0-1.972.897-1.972 1.993Zm9.277.62-.966-2.613h-.79l1.552 3.99h.381l1.579-3.99h-.776l-.98 2.612Zm2.082 1.387h2.065v-.671h-1.34V12.19h1.284v-.686H25.23v-.881h1.339v-.687h-2.065v4Zm4.847-2.82c0-.747-.466-1.18-1.301-1.18h-1.055v4h.712V12.34h.096l.986 1.598h.877l-1.15-1.687c.534-.12.835-.522.835-1.134Zm-1.407.627h-.22v-1.161h.235c.486 0 .736.198.736.566 0 .382-.25.595-.75.595Zm1.807-1.462c0 .03-.02.046-.058.046h-.013v-.09h.014c.039.001.057.015.057.044Zm.114.236-.106-.142c.045-.012.071-.047.071-.096 0-.067-.044-.105-.122-.105h-.103v.343h.076v-.133l.09.133h.094Zm.135-.172c0-.164-.125-.299-.276-.299a.27.27 0 0 0-.2.087.308.308 0 0 0-.081.212c0 .166.125.3.28.3.152-.001.277-.136.277-.3Zm-.057 0c0 .135-.099.245-.22.245-.123 0-.225-.11-.225-.244 0-.137.1-.245.224-.245.122 0 .221.11.321.245Z"
            fill="#000"
          />
          <path
            d="M18.667 9.938c-1.105 0-2 .885-2 1.97 0 1.172.853 2.03 2 2.03 1.118 0 2-.872 2-2 0-1.115-.868-2-2-2Z"
            fill="#DB8135"
          />
        </g>
      </g>
    </SvgWrapper>
  );
}
